import { Box, Text } from '@mantine/core';
import { observer } from 'mobx-react';
import { BannerContainer } from './BannerContainer';

type BannerProps = {
  maxWidth?: string;
  minWidth?: string;
  padding?: string;
  innerPadding?: string;
  margin?: string;
  link?: string | null;
  title?: string;
  description?: string;
  color?: string;
  children?: React.ReactNode;
};

export const Banner = observer(
  ({
    maxWidth,
    minWidth,
    padding,
    innerPadding = '20px',
    margin,
    title,
    description,
    color,
    link,
    children,
  }: BannerProps) => {
    return (
      <BannerContainer
        margin={margin}
        padding={padding}
        maxWidth={maxWidth}
        minWidth={minWidth}
      >
        <Box
          p={innerPadding}
          style={{ borderRadius: 8, border: `solid 2px ${color ?? 'red'}` }}
        >
          {title ?? <Text fw="600">{title}</Text>}
          <Text>{description}</Text>
          {link && (
            <a style={{ wordBreak: 'break-word' }} href={link}>
              {link}
            </a>
          )}
          {children}
        </Box>
      </BannerContainer>
    );
  },
);
